import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CTA = () => {
  const navigate = useNavigate()
  return (
    <section className="hob-cta-section">
      <div className="hob-cta-container">
        <div className="hob-cta-left">
          <h2 className="hob-cta-heading">
            Ready to Take the First Step Toward Healing?
          </h2>
          <p className="hob-cta-description">
            Begin your journey toward mental wellness with compassionate,
            professional care. Whether you’re seeking support for stress,
            relationships, or personal growth, we’re here to help you move forward.
          </p>
          <div
            className="hob-cta-button"
            onClick={() => navigate("/book-session")}
            style={{ cursor: "pointer" }}
          >
            Book a Session
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
